module.exports = __webpack_public_path__ + "img/link_to_url.ea8a941f.svg";